(() => {
  function syncDots(carousel, page) {
    const dots = carousel.querySelectorAll('.js-product-gallery-dot');
    if (!dots.length) return;
    const idx = Number(page);
    const i = Number.isFinite(idx) ? idx - 1 : 0;
    dots.forEach((dot, k) => {
      const on = k === i;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }

  function wireCarousel(carousel) {
    const dotsWrap = carousel.querySelector('.js-product-gallery-dots');
    if (!dotsWrap) return;
    const dots = carousel.querySelectorAll('.js-product-gallery-dot');
    if (!dots.length) return;
    if (carousel.dataset.galleryDotsWired === 'true') return;
    carousel.dataset.galleryDotsWired = 'true';

    const items = carousel.querySelectorAll('.js-carousel-item');
    const currentEl = carousel.querySelector('.js-carousel-counter-current');

    carousel.addEventListener('itemChanged', (e) => {
      const p = e.detail && e.detail.currentPage;
      if (p != null) syncDots(carousel, p);
    });

    if (currentEl && currentEl.textContent) {
      syncDots(carousel, currentEl.textContent.trim());
    }

    if (currentEl && typeof MutationObserver !== 'undefined') {
      const mo = new MutationObserver(() => {
        const t = currentEl.textContent && currentEl.textContent.trim();
        if (t) syncDots(carousel, t);
      });
      mo.observe(currentEl, { childList: true, characterData: true, subtree: true });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const i = Number(dot.dataset.slideIndex);
        const el = items[i];
        if (!el || typeof el.scrollIntoView !== 'function') return;
        el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  function init() {
    document.querySelectorAll('sht-carousel[id^="productGalleryCarousel-"]').forEach(wireCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
